import { Component, ContentChildren } from '@angular/core';
import { SuiTabContent } from './tab-content';
import { SuiTab } from './tab';
var SuiTabset = (function () {
    function SuiTabset() {
        this._loadedTabs = [];
    }
    /**
     * @return {?}
     */
    SuiTabset.prototype.ngAfterContentInit = function () {
        var _this = this;
        //Once we have loaded and found all child suiTabs and suiTabHeaders, link them together
        this.loadTabs();
        this._tabs.changes.subscribe(function (tabHeaders) {
            setTimeout(function () {
                _this.loadTabs();
            });
        });
    };
    /**
     * @return {?}
     */
    SuiTabset.prototype.loadTabs = function () {
        var _this = this;
        this._loadedTabs = this._tabs.toArray();
        if (!this._loadedTabs.length) {
            throw new Error("You cannot have no tabs!");
        }
        //For every content header we have managed to find,
        this._loadedTabs.forEach(function (t, i) {
            //Assuming they have an associated content
            if (!t.content) {
                //Link the content header with the content with the same ID excluding ones that are already linked
                var /** @type {?} */ possibleContents = _this._tabContents.filter(function (tC) { return tC.id == t.id; });
                if (possibleContents.length == 0) {
                    throw new Error("A [suiTabHeader] must have a related [suiTabContent].");
                }
                if (possibleContents.length > 1) {
                    throw new Error("A [suiTabHeader] must not have more than 1 related [suiTabContent].");
                }
                t.content = possibleContents.pop();
            }
            t.index = i;
            //Next observe the content's state to catch any changes made anywhere
            t.stateChanged$.subscribe(function (t) { return _this.tabStateChanged(t); });
        });
        setTimeout(function () {
            //If there isn't an active content that is currently a loaded content already, activate the first available content
            if ((_this._activeTab && !_this._loadedTabs.find(function (t) { return t == _this._activeTab; })) || !_this._activeTab) {
                _this.activateFirstTab();
            }
        });
    };
    /**
     * @param {?} tab
     * @return {?}
     */
    SuiTabset.prototype.tabStateChanged = function (tab) {
        //Check if the content is now active
        if (tab.isActive && this._activeTab != tab) {
            //If so, deactivate all other tabs that aren't this one
            this._loadedTabs
                .filter(function (tH) { return tH != tab; })
                .forEach(function (tH) { return tH.isActive = false; });
            //Set this content to be the current active content
            this._activeTab = tab;
        }
        else if (this._activeTab && !this._loadedTabs.find(function (tH) { return tH.isActive; })) {
            this.activateClosestTab(this._activeTab);
        }
        //Check if the content is now disabled, and if so if is currently active
        if (tab.isDisabled && tab.isActive) {
            //If so, unset the content as it is now disabled
            tab.isActive = false;
            //Find the first available content to activate
            this.activateClosestTab(tab);
        }
        //Check if all of the tabs are disabled
        if (tab.isDisabled && !this._loadedTabs.filter(function (tH) { return !tH.isDisabled; }).length) {
            throw new Error("You cannot disable all of your tabs!");
        }
    };
    /**
     * @return {?}
     */
    SuiTabset.prototype.activateFirstTab = function () {
        //Filter out all disabled tabs from the currently loaded list and take the first one
        var /** @type {?} */ firstAvailable = this._loadedTabs.filter(function (tH) { return !tH.isDisabled; })[0];
        if (firstAvailable) {
            //If there is one available, activate it and set it to the currently active content
            firstAvailable.isActive = true;
            //Note, because we are observing each content's state, this.activeTab will be updated by this setter
        }
    };
    /**
     * @param {?} tab
     * @return {?}
     */
    SuiTabset.prototype.activateClosestTab = function (tab) {
        //Grab a list of all of the loaded tabs that aren't disabled (excluding the one we are leaving)
        var /** @type {?} */ availableTabs = this._loadedTabs
            .filter(function (tH) { return !tH.isDisabled; });
        var /** @type {?} */ tabIndex = tab.index;
        // Only change the tabIndex if we have to.
        if (tabIndex >= availableTabs.length) {
            tabIndex = availableTabs.length - 1;
        }
        availableTabs[tabIndex].isActive = true;
        //This if we just activated a disabled content, not to worry as it will bubble through
    };
    return SuiTabset;
}());
export { SuiTabset };
SuiTabset.decorators = [
    { type: Component, args: [{
                selector: 'sui-tabset',
                exportAs: 'suiTabset',
                template: "\n<ng-content></ng-content>\n",
                styles: ["\n:host .ui.segment {\n    margin-bottom: 0;\n}\n"]
            },] },
];
/**
 * @nocollapse
 */
SuiTabset.ctorParameters = function () { return []; };
SuiTabset.propDecorators = {
    '_tabs': [{ type: ContentChildren, args: [SuiTab,] },],
    '_tabContents': [{ type: ContentChildren, args: [SuiTabContent,] },],
};
function SuiTabset_tsickle_Closure_declarations() {
    /** @type {?} */
    SuiTabset.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    SuiTabset.ctorParameters;
    /** @type {?} */
    SuiTabset.propDecorators;
    /** @type {?} */
    SuiTabset.prototype._tabs;
    /** @type {?} */
    SuiTabset.prototype._tabContents;
    /** @type {?} */
    SuiTabset.prototype._loadedTabs;
    /** @type {?} */
    SuiTabset.prototype._activeTab;
}
export var /** @type {?} */ SUI_TABS_DIRECTIVES = [SuiTabset, SuiTab, SuiTabContent];
//# sourceMappingURL=tabset.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ng2-semantic-ui/components/tabs/tabset.js
// module id = ./node_modules/ng2-semantic-ui/components/tabs/tabset.js
// module chunks = vendor